import { Box, styled, SxProps } from "@mui/material";
import { DomainIconDisplay } from "~/types/enums/domain";

const IconContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 24,
  height: 24,
  "& svg": {
    width: 16,
    height: 16,
  },
  borderRadius: "50%",
});

const DomainIcon = (props: DomainIconDisplay & { sx?: SxProps }) => (
  <IconContainer bgcolor={props.backgroundColor} sx={props.sx}>
    <props.icon color={props.iconColor} />
  </IconContainer>
);

export default DomainIcon;
